import { apiGet, apiPost } from "./client.js";
import type { Organisation, OrgType } from "./types.js";

export interface CreateOrgRequest {
  orgName: string;
  orgType: OrgType;
  country: string;
  accessibilityContactEmail: string;
}

export interface CreateOrgResponse {
  ok: boolean;
  org: Organisation;
}

export interface ListOrgsResponse {
  orgs: Organisation[];
}

export function createOrg(data: CreateOrgRequest): Promise<CreateOrgResponse> {
  return apiPost<CreateOrgResponse>("/orgs", data);
}

export function listOrgs(): Promise<ListOrgsResponse> {
  return apiGet<ListOrgsResponse>("/orgs");
}

export function getOrg(orgId: string): Promise<{ org: Organisation }> {
  return apiGet<{ org: Organisation }>(`/orgs/${orgId}`);
}
